<template>
    <div
        :class="statusBuilder(
            'Body',
            '',
            false,
            {
                compact: compact,
            })"
    >
        <div
            v-if="!compact"
            class="Body__link-container"
            @click.stop=""
        >
            <a
                class="Body__link"
                @click.stop="$emit('nav-to-url', review.review_url)"
            >
                <RPSiteBadge
                    :name="profile.site.name.toLowerCase()"
                    class="Body__site-badge"
                />{{ profile.site.name }}
            </a>
            <a
                v-if="review.metadata"
                :class="statusBuilder('Body__link', '', false, {
                    open: showAdditionalInfo === 'meta'
                })"
                @click.stop="toggleAdditionInfo('meta')"
            >Metadata</a>
            <a
                class="Body__link"
            >
                <!--TODO Campaigns-->
                Campaigns
            </a>
            <a
                v-if="!!review.attributed_review_id"
                class="Body__link"
                @click.stop="$emit('nav-to-attributed', review.attributed_review_id)"
            >Other Source</a>
        </div>
        <div class="Body__avatar-container">
            <RPUserAvatar
                :avatar="review.user_profile_image"
            />
        </div>
        <div
            :class="statusBuilder(
                'Body__review-container',
                '',
                false,
                {
                    compact: compact,
                })"
        >
            <div class="Body__review-header">
                <div class="Body__user">
                    {{ userName }}<span class="Body__time">{{ timeSince }}</span>
                </div>
                <RPStarCounter
                    :rating="review.rating"
                    :status="status"
                />
            </div>
            <div class="Body__review">
                {{ reviewText }}
            </div>
            <template v-if="!compact">
                <div
                    v-if="showAdditionalInfo === 'images' && review.images.length"
                    class="Body__review-images"
                >
                    <img
                        v-for="(img, index) in review.images"
                        :key="`image-${index}`"
                        class="Body__image"
                        :src="img"
                        :alt="`image_${index}`"
                        @click.stop="modalImage = img"
                    >
                </div>
                <div
                    v-if="showAdditionalInfo === 'meta' && review.metadata"
                    class="Body__meta-container"
                >
                    <div
                        class="Body__meta-header"
                        @click.stop="toggleAdditionInfo('meta')"
                    >
                        Metadata
                        <StreamlineIcon
                            class="Body__header-icon"
                            :icon="RemoveCircleBold"
                            :fill="textGrey"
                            :stroke="white"
                            :size="12"
                        />
                    </div>
                    <!-- TODO Metadata display section-->
                </div>
            </template>
        </div>
        <RPModal
            v-if="modalImage !== ''"
            :show-action-buttons="false"
            status="custom"
            @close-modal="modalImage = ''"
        >
            <template slot="modalBody">
                <img
                    class="Body__full-image"
                    :src="modalImage"
                    :alt="modalImage"
                >
            </template>
        </RPModal>
    </div>
</template>
<script>
import statusBuilder from 'status/statusBuilder';
import stat from 'status/index';
import RPSiteBadge from 'components/Basic/Misc/RPSiteBadge';
import RPUserAvatar from 'components/Basic/Misc/RPUserAvatar.vue';
import {RemoveCircleBold} from '@reviewpush/streamline-bold/lib/interface-essential/RemoveAdd';
import {textGrey, white} from 'style/_colors.scss';
import moment from 'moment';
import RPStarCounter from 'components/Basic/Misc/RPStarCounter';
import RPModal from 'components/Complex/Modal/RPModal.vue';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";

export default {
    name: 'Body',
    components: {
        RPSiteBadge,
        RPUserAvatar,
        RPStarCounter,
        RPModal,
        StreamlineIcon
    },
    props: {
        review: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        compact: {
            type: Boolean,
            default: false
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    data(){
        return{
            RemoveCircleBold,
            textGrey,
            white,
            showAdditionalInfo: '',
            modalImage: ''
        };
    },
    computed: {
        defaultAdditionalInfo(){
            return this.review.images.length ? 'images' : '';
        },
        userName(){
            return this.review.reviewer === ''? 'Anonymous' : this.review.reviewer;
        },
        timeSince(){
            //Days Calculation
            const dateDiff = moment().diff(moment(this.review.review_date, 'YYYY-MM-DD'), 'days');
            if(dateDiff > 0) {
                return `${dateDiff} ${dateDiff > 1 ? 'days' : 'day'} ago`;
            }
            //Hours Calculation
            const reviewTime = moment(`${this.review.review_date} ${this.review.review_time}`, 'YYYY-MM-DD HH:mm:ss');
            const hoursDiff = moment().diff(reviewTime, 'hours');
            if(hoursDiff > 0) {
                return `${hoursDiff} ${hoursDiff > 1 ? 'hrs' : 'hr'} ago`;
            }
            //Minutes Calculation
            const minDiff = moment().diff(reviewTime, 'minutes');
            if(minDiff > 0) {
                return `${minDiff} ${minDiff > 1 ? 'mins' : 'min'} ago`;
            }
            //Seconds Calculation
            const secDiff = moment().diff(reviewTime, 'seconds');
            return `${secDiff} ${secDiff > 1 ? 'seconds' : 'second'} ago`;
        },

        reviewText(){
            if(!this.compact || (this.compact && this.review.review.length < 120)) {
                return this.review.review;
            }
            return this.review.review.substr(0, 120)+'...';
        },
    },
    mounted(){
        this.showAdditionalInfo = this.defaultAdditionalInfo;
    },
    methods: {
        statusBuilder,
        toggleAdditionInfo(info){
            this.showAdditionalInfo = info !== this.showAdditionalInfo
                ? info
                : this.defaultAdditionalInfo;
        }
    }
};
</script>
<style lang="scss">
.Body {
    padding: 1.5rem 1rem;
    display: grid;
    grid-template-columns: min-content min-content auto;
    grid-gap: 1rem;

    &--compact {
        grid-template-columns: min-content auto;
    }

    &__link-container {
        width: 6rem;
        display: flex;
        flex-direction: column;
        color: $text-link;
    }
    &__link {
        cursor: pointer;
        font-size: 0.85rem;
        line-height: 1rem;
        color: $text-link;
        text-decoration: none;
        margin-bottom: 0.25rem;
        white-space: nowrap;
        display: flex;
        align-items: center;
        &--open {
            color: $text-grey;
            font-weight: 600;
            &:hover {
                text-decoration: none;
            }
        }
    }
    &__site-badge{
        height: 0.75rem;
        width: 0.75rem;
        margin: auto 2px auto 0;
    }

    &__review-container {
        display: flex;
        flex-direction: column;
        &--compact {
            flex-direction: row;
            align-content: center;
        }
    }
    &__review-header {
        margin-right: 1rem;
        white-space: nowrap;
        margin-bottom: 0.5rem;
    }
    &__user {
        color: $text-dark;
        font-weight: 600;
        font-size: 1rem;
        margin-bottom: 0.5rem;
    }
    &__time {
        margin-left: 0.25rem ;
        color: $text-grey;
        font-size: 0.7rem;
        font-weight: normal;
    }
    &__review {
        color: $text-grey;
        margin-bottom: 1rem;
    }
    &__review-images {
        display: flex;
    }
    &__image {
        cursor: pointer;
        background: $white;
        border: 1px solid $grey-50;
        width: 7.5rem;
        height: auto;
        border-radius: 4px;
        margin-right: 0.5rem;
    }
    &__full-image {
        height: auto;
        max-width: 45rem;
    }
    &__meta-container {
    }
    &__meta-header {
        display: flex;
        align-items: center;
        position: relative;
        height:1rem;
        cursor: pointer;
        color: $text-dark;
        font-weight: 600;
    }
    &__header-icon {
        margin-left: 0.25rem;
    }
    &__meta-placeholder {
        height: 1rem;
        width: 1rem;
    }
}
</style>
